import styled from 'styled-components'

// Convertible toglie il round top del tab content perchè sono visualizzati i tab
export const TabContent = styled.div<{ convertible: boolean }>`
  background-color: ${({ theme }) => theme.colors.background};
  /* padding: 0.5rem 0.5rem 1rem 0.5rem; */
  padding: 2rem 1.2rem;
  width: 100%;
  min-width: 25rem;
  max-width: 80rem;
  border-radius: ${({ convertible }) =>
    convertible ? '0 0.5rem 0.5rem 0.5rem' : '0.5rem'};
`

export const Tabs = styled.div`
  width: 100%;
  min-width: 25rem;
  margin: 0;
  padding: 0;
  display: flex;
  align-items: center;
`

export const Tab = styled.div<{ order: number; isSelected: boolean }>`
  display: flex;
  align-items: center;
  justify-content: center;
  order: ${({ order }) => order};
  background-color: ${({ isSelected, theme }) =>
    isSelected ? theme.colors.boxBackground : theme.colors.background};
  border-radius: 5px 5px 0 0;
  cursor: pointer;
  margin-right: 1rem;
  color: ${({ theme }) => theme.colors.primary};
  padding: 0.8rem 0;
  user-select: none;
`

export const Table = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-evenly;

  @media screen and (min-width: 768px) {
    flex-direction: column;
  }
`

export const Row = styled.div<{
  convertible: boolean
  nColumn: number
  firstCellFixed?: boolean
  showSeparator?: boolean
  large?: boolean
}>`
  position: relative;
  display: flex;
  flex-direction: column;
  padding: 0 1rem;
  flex: 1;

  @media screen and (max-width: 767px) {
    &:nth-child(5) {
      flex: 0;
      padding: 0;

      > * {
        transform: rotate(-90deg);
      }
    }
  }

  @media screen and (min-width: 768px) {
    width: 100%;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    padding: ${({ large }) => (large ? '1rem' : '0.5rem 1rem')};
    margin: 0;
  }

  &:first-child {
    border-bottom: ${({ theme, convertible }) =>
      !convertible && `0.1rem solid ${theme.colors.secondary}`};
  }

  &::after {
    content: '';
    position: absolute;
    bottom: 0;
    right: 0;
    background: ${({ theme, showSeparator }) =>
      showSeparator && theme.colors.secondary};

    @media screen and (max-width: 767px) {
      width: 0.1rem;
      height: ${({ firstCellFixed }) =>
        firstCellFixed ? `calc(100% - 4rem)` : `100%`};
    }

    @media screen and (min-width: 768px) {
      width: ${({ firstCellFixed }) =>
        firstCellFixed ? `calc(100% - 10rem)` : `100%`};
      height: 0.1rem;
    }
  }

  &:nth-child(3)::after {
    @media screen and (min-width: 768px) {
      background: transparent;
    }
  }
`

export const Size = styled.div<{
  bold?: boolean
  highlight?: boolean
  secondary?: boolean
}>`
  padding: 1rem 0;

  &:first-child {
    height: 3rem;
    margin: 0 -1rem;
    padding: 0;
  }

  @media screen and (min-width: 768px) {
    min-width: 2.6rem;
    padding: 0;
    transform: rotate(0deg);

    &:first-child {
      min-width: 8rem;
      height: auto;
      margin: 0;
    }
  }
`
